




























import Vue, { PropType } from "vue";
import LazyImage from "@/components/LazyImage.vue";

export default Vue.extend({
  components: {
    LazyImage
  },
  props: {
    name: String as PropType<string>,
    val: String as PropType<string>,
    value: String as PropType<string>,
    text: String as PropType<string>,
    image: String as PropType<string>,
    checked: Boolean as PropType<boolean>
  },
  methods: {
    onChange(value: string): void {
      this.$emit("input", value);
    }
  }
});
